import { LogsService, LogsProvider, HttpService } from '@lk/api'

export const makeLogsService = (http: HttpService, baseUrl: string) => new LogsService(new LogsProvider(http, baseUrl))
